import axios from "axios";
import Config from "../config/Config";
import authHeader from "./auth-header";

const API_PUBLIC_URL = Config.BASE_URL_API_PUBLIC;

const functionsPayment = {
	createPrepaidPayment(value: number, billingType: string){
		return axios.post(API_PUBLIC_URL + `/payment/create`, {
			value: value,
			billingType: billingType
		}, {
			headers: authHeader()
		});
	},
	getPrepaidPayments(){
		return axios.get(API_PUBLIC_URL + `/payments`, { headers: authHeader() });
	}
};

export default functionsPayment;